;(function($) {
    var pluginName = 'rkasEqualHeight';
    var defaults = {};
    var initSelector = '[data-equalheight]';

    /**
     * EqualHeight
     * @class
     * @param {jQuery} $elements Elements in the group
     * @param {Object} options   An option map
     */
    function EqualHeight($elements, options) {
        this.$elements = $elements;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.resizeTimer = 0;

        this.init();
    }

    /**
     * Initialize the plugin.
     * @method init
     * @returns {void}
     */
    EqualHeight.prototype.init = function() {
        this.setHeights();

        $(window).on('resize.rkas.equalHeight', this.resizeHandler.bind(this));
        $(document).on('refresh.rkas.equalHeight', this.refreshHandler.bind(this));
    };

    /**
     * Delay the resize method to make sure resizing has finished.
     * @method resizeHandler
     * @returns {void}
     */
    EqualHeight.prototype.resizeHandler = function() {
        var that = this;

        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(function() {
            that.setHeights();
        }, 250);
    };

    /**
     * Check if current instance is in target and set new heights if true.
     * @method refreshHandler
     * @param   {Event} event  An event object
     * @param   {HTMLElement} target Containing HTML element
     * @returns {void}
     */
    EqualHeight.prototype.refreshHandler = function(event, target) {
        var contains = false;

        if(target === undefined) return;

        // loop through all elements to see if any of them is inside target
        this.$elements.each(function() {
            if ($.contains(target, this)) {
                contains = true;
            }
        });

        if (target && contains) {
            this.setHeights();
        }
    };

    /**
     * Set equal heights to all elements in the group.
     * @method setHeights
     * @returns {void}
     */
    EqualHeight.prototype.setHeights = function() {
        var currentTallest = 0;
        var currentRowStart = 0;
        var rowDivs = [];
        var $el;
        var topPosition = 0;

        this.$elements.each(function() {
            $el = $(this);
            $el.css({
                'min-height': '0'
            });
            topPosition = $el.offset().top;
            // debugger;
            if (currentRowStart != topPosition) {
                for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].css({
                        'min-height': currentTallest
                    });
                }
                rowDivs.length = 0;
                currentRowStart = topPosition;
                currentTallest = $el.outerHeight() + 1;
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                // currentTallest = (currentTallest < $el.height()) ? ($el.height() + 1) : (currentTallest);
                currentTallest = (currentTallest < $el.outerHeight()) ? ($el.outerHeight() + 1) : (currentTallest);
            }
            if (rowDivs.length > 1) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].css({
                        'min-height': currentTallest
                    });
                }
            }
        });
    };

    /**
     * Destroy the plugin instance
     * @method destroy
     * @returns {void}
     */
    EqualHeight.prototype.destroy = function() {
        $(window).off('resize.rkas.equalHeight');

        this.$elements.css('min-height', '');
        $(this.$elements[0]).removeData('plugin_' + pluginName);
    };

    /**
     * Create jQuery plugin.
     * @param {Object} options Extended options
     * @listens rkas.equalHeight
     * @returns {Array<EqualHeight>} Array of EqualHeights
     */
    $.fn[pluginName] = function(options) {
        var args = Array.prototype.slice.call(arguments, 1);
        var groups = {};

        this.each(function() {
            var $this = $(this);
            var groupId = $this.attr('data-equalheight');

            if (groupId in groups) {
                groups[groupId] = groups[groupId].add($this);
            } else {
                groups[groupId] = $this;
            }
        });

        $.each(groups, function() {
            var first = this[0];
            var instance = $.data(first, 'plugin_' + pluginName);

            if (!instance) {
                $.data(first, 'plugin_' + pluginName, new EqualHeight(this, options));
            } else if (typeof options === 'string') {
                instance[options].apply(instance, args);
            }
        });

        return this;
    };

    /**
     * @event enhance.rkas.equalHeight
     * @param   {Event} event
     */
    $(document).on('enhance.rkas.equalHeight', function(event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]();
    });

    /**
     * @event destroy.rkas.equalHeight
     * @param   {Event} event
     */
    $(document).on('destroy.rkas.equalHeight', function(event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]('destroy');
    });

    /**
     * Auto-init the plugin on DOM ready.
     * @fires enhance.rkas.equalHeight
     */
    $(function() {
        $(document).trigger('enhance.rkas.equalHeight');
    });
}(jQuery));
